/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const wallet_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M22 11.5V8a2 2 0 0 0-2-2h-1m3 5.5h-4.5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1H22m0-5h.5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H22m0 0V21a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m0 0 10.467-4.55a1 1 0 0 1 1.357.629L19 6M6 6h13m-.179 8.003h.346m.08 0c0 .183-.16.243-.249.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    />
  </svg>
)
export default wallet_medium
